/**
 * 困ったときガイドの版（/guide/welcia 等）。
 *
 * **どの版かを決めるのは back。** front は法人 UUID の表を持たず、`check_auth` が返す
 * `guide_variant` を受け取るだけ（hub design-book ADR-0051）。法人 UUID は DB の事実で、
 * 同じ法人でも本番と staging では別の行になるため、bundle に焼くと片方の環境で死にキーに
 * なる。版は法人だけで決まり、app_type（どの画面を出すか）とは独立。
 *
 * 紙のA4シートのQRは法人の版を直接指す。アプリ内の導線（ポータルの［困ったときガイド］・
 * 報告モーダル）は入口だけでは閲覧者が分からないので、ログイン時に受け取った版名を使う。
 *
 * 版名は back の `users/guide_variant.py`・S3 の `downloads/guide/{版}.pdf`・
 * 紙（Figma）と 1:1。版を足すときは 4 つ同時。
 */
import { localStorageWrapper } from '../helpers/localStorage'

export const GUIDE_VARIANTS = ['default', 'welcia', 'aisei'] as const

export type GuideVariantName = (typeof GUIDE_VARIANTS)[number]

export const DEFAULT_GUIDE_PATH = '/guide'

/** back が解決した版名を受ける。取得前・知らない版名は共通版 */
export const guideVariantOf = (name?: string | null): GuideVariantName =>
  GUIDE_VARIANTS.find((variant) => variant === name) ?? 'default'

/** 版名 → ガイドのパス。routes.tsx の route もこの関数から組む（パスを 2 か所に書かない） */
export const guidePath = (variant: GuideVariantName): string =>
  variant === 'default'
    ? DEFAULT_GUIDE_PATH
    : `${DEFAULT_GUIDE_PATH}/${variant}`

/** アプリ内の導線から開くガイドのパス。 */
export const currentGuidePath = (): string =>
  guidePath(guideVariantOf(localStorageWrapper.getItem('guide_variant')))
